import { useQuery } from '@tanstack/react-query'
import day from 'dayjs'
import { getDistributionDate } from '@App/api/routes/system-settings'

export const NEXT_DISTRIBUTION_DATE_QUERY_KEY = 'next-distribution-date'

const useNextDistributionDate = (enabled = true): string | undefined => {
    const { data } = useQuery({
        queryKey: [NEXT_DISTRIBUTION_DATE_QUERY_KEY],
        queryFn: async () => (await getDistributionDate()).data.distributionDate,
        enabled,
    })

    return data ? day(data).format('MMMM D, YYYY') : undefined
}

export default useNextDistributionDate
